<template>
  <main v-if="!selectedPayment" class="main_inner flex-grow-1 loading" />
  <main v-else id="deposit_wrap">
    <div class="deposit_area account_area d-grid">
      <div class="account_wrap">
        <div class="account_wrap-container">
          <h5 class="account_title mb-3">
            {{ $t("Bao.deposit") }}
          </h5>
          <div id="deposit_items">
            <button v-for="(channel, key) in types" :key="key" type="button" :class="(selectedType.id == channel.id ? 'active' : '')" @click="selectType(channel)">
              {{ channel.name }}
            </button>
            <button
              v-if="
                depositBankcardInternal && depositBankcardInternal.enabled
              "
              type="button"
              @click="showModal()"
            >
              {{
                $t("Bao.bankcard_internal_vips")
              }}
            </button>
          </div>
          <h5 class="account_title mt-4 mb-3">
            1.{{
              selectedType.id == "manual"
                ? $t("Bao.deposit_bank")
                : $t("Bao.select_payment_provider")
            }}
          </h5>
          <div id="aisle_items">
            <button
              v-for="(payment, key) in selectedType.payments"
              :key="key"
              type="button"
              :class="
                (selectedPayment.payment_id == payment.payment_id
                  ? 'active'
                  : '')
              "
              @click="selectPayment(payment)"
            >
              {{ payment.name }}
            </button>
          </div>
          <div class="wallet_pay_block">
            <div v-if="selectedType.id == 'manual'">
              <br>
              {{ $t("Bao.bank_name") }}
            </div>
            <div
              v-if="selectedType.id == 'manual'"
              class="deposit_two d-grid"
            >
              <div class="wallet_pay_key">
                <input
                  class="wallet_pay_ipt w-100 is_true"
                  type="text"
                  :value="selectedBank.bank_name"
                  readonly
                >
              </div>
              <button
                class="btn btn_clear"
                type="button"
                @click="copy(selectedBank.bank_name)"
              >
                {{ $t("Bao.copy") }}
              </button>
            </div>
          </div>
          <h5 class="account_title mt-4 mb-3">
            2. {{ $t("Bao.select_payment_amount") }}
          </h5>
          <div class="payment_wrap">
            <input
              v-model="postForm.amount"
              v-validate="
                'required|integer|min_value:' +
                  selectedPayment['amount_limit'].min +
                  '|max_value:' +
                  selectedPayment['amount_limit'].max
              "
              :data-vv-as="$t('Bao.amount')"
              name="amount"
              type="number"
              :class="[
                'wallet_pay_ipt',
                'w-100',
                'is_true',
                { 'text-black': amountChange },
              ]"
              pattern="\d*"
              step="1"
              required
              :placeholder="$t('Bao.please_input_deposit_amount')"
              :disabled="!isCustomAmount"
              @keyup="handleKeyup($event.target.value)"
              @change="amountChange = true"
            >
            <small v-if="errors.has('amount')" class="help-block custom-error-msg">
              {{ errors.first("amount") }}
            </small>
            <button v-for="(price, key) in selectedPayment.price_list" :key="key" type="button" @click="handleAmount(price)">
              {{ price }}
              <div v-if="getPrize(price) !== ''">
                <span>+{{ getPrize(price) }}%</span>
              </div>
            </button>
          </div>
          <div class="total_bonus" :class="{ 'active': eventJoin }">
            <label id="chk_use_bouns_lbl" for="chk_use_bouns" class="use_bouns">
              <input id="chk_use_bouns" v-model="eventJoin" type="checkbox">
              Bouns {{ eventBonus }}
            </label>
            <div v-if="eventJoin" class="total_box">
              Total {{ calulateTotalBonus() }}
            </div>
            <div v-else class="total_box">
              Total {{ postForm.amount }}
            </div>
          </div>
          <button
            id="deposit_submit"
            type="submit"
            :disabled="actionLoading"
            @click="handleSubmit()"
          >
            {{ $t("Bao.confirm") }}
          </button>
        </div>
      </div>
    </div>

    <div class="card-body card_collapse_body bg-transparent">
      <div class="deposit_pay_inner d-grid">
        <div class="deposit_pay">
          <input
            id="deposit_pay"
            ref="checkDeposit"
            class="deposit_pay_ipt d-none"
            type="checkbox"
          >
        </div>
        <!--modal_set-->
        <b-modal
          v-if="depositBankcardInternal"
          id="modal_set"
          ref="modal_set"
          modal-class="modal modal_tips fade"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          dialog-class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md"
          header-class="modal-header justify-content-start align-items-center border-bottom-0"
          body-class="text-center"
          footer-class="modal-footer justify-content-center border-top-0"
        >
          <template v-slot:modal-header>
            <h4 class="mb-0">
              <b>{{ $t("Bao.notice") }}</b>
            </h4>
            <button
              type="button"
              class="close rounded-circle m-0"
              data-dismiss="modal"
              aria-label="Close"
              @click="$bvModal.hide('modal_set')"
            >
              <i class="icon-clear" />
            </button>
          </template>
          <h6 class="mb-0">
            {{ depositBankcardInternal.show_message }}
          </h6>
          <template v-slot:modal-footer>
            <div
              class="wallet_transfer_btn d-flex justify-content-center w-100"
            >
              <button
                type="button"
                class="btn btn_ok text-white"
                data-dismiss="modal"
                @click="goToCsPage()"
              >
                {{ $t("Bao.contanct_service") }}
              </button>
            </div>
          </template>
        </b-modal>
      </div>
    </div>

    <!--modal_set-->
    <b-modal
      id="modal_bank_info"
      ref="modal_bank_info"
      modal-class="modal_bet_detail"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      dialog-class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md"
      header-class="modal-header justify-content-start align-items-center border-bottom-0"
      body-class=""
      footer-class="modal-footer justify-content-center border-top-0"
    >
      <template v-slot:modal-header>
        <h4 class="mb-0">
          <b>{{ $t("Bao.notice") }}</b>
        </h4>
      </template>
      <div v-if="selectedBank" id="modal_bank_info_body">
        <form class="mb-0" autocomplete="off">
          <div v-if="selectedBank.money_transfer_info_use_image != 1">
            <div class="form-group">
              <h6 class="mb-0">
                {{ $t("Bao.deposit_notice") }}
              </h6>
            </div>
            <div class="form-group">
              <label class="form_lab">{{ $t("Bao.bank_name") }}</label>
              <!--<input v-model="updateUser.withdrawal_pass" v-validate="'min:4|max:4|integer'" :data-vv-as="$t('Bao.withdrawal_pass')" name="withdrawal_pass" :class="inputClasses('withdrawal_pass')" :type="inputType" :placeholder="$t('Bao.has_set') + ' ' + $t('Bao.please_leave_blank_if_not_set')" maxlength="4" @focus="changeType()">-->
              <div class="row">
                <div class="col-10">
                  <input
                    class="form-control"
                    type="text"
                    :value="selectedBank.bank_name"
                    readonly
                    style="color: rgb(0, 0, 0)"
                  >
                </div>
                <div class="col-2">
                  <button
                    class="
                      btn btn_ok
                      text-white
                      bank_info_copy_btn
                      btn btn_outline btn_del
                      w-90
                      btn_copy
                    "
                    type="button"
                    @click="copyOfModal(selectedBank.bank_name)"
                  >
                    {{ $t("Bao.copy") }}
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="form_lab">{{ $t("Bao.bank_account_name") }}</label>
              <!--<input v-model="updateUser.withdrawal_pass" v-validate="'min:4|max:4|integer'" :data-vv-as="$t('Bao.withdrawal_pass')" name="withdrawal_pass" :class="inputClasses('withdrawal_pass')" :type="inputType" :placeholder="$t('Bao.has_set') + ' ' + $t('Bao.please_leave_blank_if_not_set')" maxlength="4" @focus="changeType()">-->
              <div class="row">
                <div class="col-10">
                  <input
                    class="form-control"
                    type="text"
                    :value="selectedBank.account_name"
                    readonly
                    style="color: rgb(0, 0, 0)"
                  >
                </div>
                <div class="col-2">
                  <button
                    class="
                      btn btn_ok
                      text-white
                      bank_info_copy_btn
                      btn btn_outline btn_del
                      w-90
                      btn_copy
                    "
                    type="button"
                    @click="copyOfModal(selectedBank.account_name)"
                  >
                    {{ $t("Bao.copy") }}
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="form_lab">{{ $t("Bao.bank_card_number") }}</label>
              <!--<input v-model="updateUser.withdrawal_pass" v-validate="'min:4|max:4|integer'" :data-vv-as="$t('Bao.withdrawal_pass')" name="withdrawal_pass" :class="inputClasses('withdrawal_pass')" :type="inputType" :placeholder="$t('Bao.has_set') + ' ' + $t('Bao.please_leave_blank_if_not_set')" maxlength="4" @focus="changeType()">-->
              <div class="row">
                <div class="col-10">
                  <input
                    class="form-control"
                    type="text"
                    :value="selectedBank.card_number"
                    readonly
                    style="color: rgb(0, 0, 0)"
                  >
                </div>
                <div class="col-2">
                  <button
                    class="
                      btn btn_ok
                      text-white
                      bank_info_copy_btn
                      btn btn_outline btn_del
                      w-90
                      btn_copy
                    "
                    type="button"
                    @click="copyOfModal(selectedBank.card_number)"
                  >
                    {{ $t("Bao.copy") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="selectedBank.use_qr_code != 1" class="form-group">
            <label class="form_lab">{{ $t("Bao.money_transfer_info") }}</label>
            <div class="row">
              <div class="col-10">
                <textarea
                  v-model="selectedBank.note"
                  class="form-control"
                  rows="5"
                  readonly
                  style="color: rgb(0, 0, 0)"
                />
              </div>
              <div class="col-2">
                <button
                  class="
                    btn btn_ok
                    text-white
                    bank_info_copy_btn
                    btn btn_outline btn_del
                    w-90
                    btn_copy
                  "
                  type="button"
                  @click="copyOfModal(selectedBank.note)"
                >
                  {{ $t("Bao.copy") }}
                </button>
              </div>
            </div>
          </div>
          <div v-if="selectedBank.use_qr_code != 0" class="form-group">
            <label class="form_lab">{{
              $t("Bao.money_transfer_info_qr_code")
            }}</label>
            <div class="row">
              <div class="col-10" style="text-align: center; margin: 0 auto">
                <img
                  :src="selectedBank.qr_code_url"
                  alt=""
                  style="width: 200px; margin-top: -10px"
                >
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="form_lab">{{ $t("Bao.money") }}</label>
            <div class="row">
              <div class="col-10">
                <input
                  class="form-control"
                  type="text"
                  :value="postForm.amount"
                  readonly
                  style="color: rgb(0, 0, 0)"
                >
              </div>
              <div class="col-2">
                <button
                  class="
                    btn btn_ok
                    text-white
                    bank_info_copy_btn
                    btn btn_outline btn_del
                    w-90
                    btn_copy
                  "
                  type="button"
                  @click="copyOfModal(postForm.amount)"
                >
                  {{ $t("Bao.copy") }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <template v-slot:modal-footer>
        <div class="wallet_transfer_btn d-flex justify-content-center w-100">
          <button type="button" class="btn btn_ok text-white" @click="okBtn">
            {{ $t("Bao.confirm") }}
          </button>
        </div>
      </template>
    </b-modal>
  </main>
</template>
<script>
import {
  DepositManual,
  DepositPayment,
  DepositType,
  DepositBankcardInternal
} from '@/api/payment'
import { getEvent, getEventDetail } from '@/api/event'
import {
  copyTextOfModal,
  copyText,
  setErrorMessage,
  showNotice
} from '@/utils/tool'
import { info } from '@/api/user'
import i18n from '@/i18n'

export default {
  name: 'Deposit',
  data() {
    const postForm = {
      payment_id: null,
      amount: '',
      other: null,
      bank_account_id: null,
      deposit_name: null,
      deposit_method: ''
    }

    return {
      actionLoading: false,
      types: [],
      listenTimer: null,
      selectedType: null,
      selectedPayment: null,
      selectedBank: null,
      checkedItem: 'amount_custom',
      postForm,
      currentPaymentName: this.$t('Bao.please_select_payment_method'),
      amountChange: false,
      firstLoad: true,
      isCustomAmount: true,
      showUSDT: false,
      USDT: '',
      depositBankcardInternal: null,
      eventDetail: {},
      eventBonus: 0,
      eventJoin: true
    }
  },
  created() {
    info().then(response => {
      const reqData = response.data
      this.$store.dispatch('SetUserData', reqData.data)
      const memberInfo = this.$store.state.user.memberInfo
      if (memberInfo.first_deposit_amount === 0 && memberInfo.first_deposit_at === 0) {
        // 沒有首存紀錄
        // 有無餘額都提示
        showNotice(i18n.t('Bao.first_deposite_clear_bonus_tip_1') + '<br />' + i18n.t('Bao.first_deposite_clear_bonus_tip_2') + '<br />' + i18n.t('Bao.first_deposite_clear_bonus_tip_3'))

        // if (this.$store.state.user.goldInfo.gold !== 0 || this.gameWallet()) {
        //   // 有餘額
        //   showNotice(i18n.t('Bao.first_deposite_clear_bonus_tip_1') + '<br />' + i18n.t('Bao.first_deposite_clear_bonus_tip_2') + '<br />' + i18n.t('Bao.first_deposite_clear_bonus_tip_3'))
        // } else {
        //   // 沒有餘額
        //   showNotice(i18n.t('Bao.first_deposite_clear_bonus_tip_1') + '<br />' + i18n.t('Bao.first_deposite_clear_bonus_tip_4'))
        // }
      }
    })
    DepositType()
      .then((response) => {
        this.types = response.data.data

        this.selectedType = this.types[0]
        this.selectPayment(this.selectedType.payments[0])
        this.firstLoad = false
      })
      .catch(() => {
      })
    DepositBankcardInternal()
      .then((response) => {
        this.depositBankcardInternal = response.data.data
      })
      .catch(() => {
      })
    getEvent()
      .then((response) => {
        for (const i in response.data.data.list) {
          if (response.data.data.list[i].type === 'deposit_v2') {
            getEventDetail(response.data.data.list[i].id).then(response => {
              this.eventDetail = response.data.data
              this.calculateBonus(this.postForm.amount)
            })
          }
        }
      })
  },
  destroyed() {
    if (this.listenTimer) {
      window.clearInterval(this.listenTimer)
    }
  },
  methods: {
    gameWallet() {
      for (const i in this.$store.state.user.gameBalanceInfo) {
        const amount = parseInt(this.$store.state.user.gameBalanceInfo[i].amount)
        if (amount !== 0) return true
      }
      return false
    },
    okBtn() {
      this.$router.push({ name: 'DepositRecord' }).catch(() => {
      })
    },
    selectType(selectedValue) {
      // console.log(selectedValue)
      this.selectedType = selectedValue
      const elem = this.$refs.checkDeposit
      elem.click()
      this.currentPaymentName = this.selectedType.name
      this.selectPayment(this.selectedType.payments[0])
    },
    selectPayment(selectedValue) {
      this.selectedPayment = selectedValue
      // this.handleAmount(this.selectedPayment.price_list[0])
      this.postForm.payment_id = selectedValue.payment_id
      if (this.selectedPayment.show_custom_amount === 0) {
        this.isCustomAmount = false
      } else {
        this.isCustomAmount = true
      }
      if (this.selectedType.id === 'manual') {
        this.selectBank(selectedValue.others.info)
      }
      if (
        this.selectedPayment.usdt_rate !== undefined &&
        this.selectedPayment.usdt_rate > 0
      ) {
        this.showUSDT = true
      } else {
        this.showUSDT = false
      }
    },
    selectBank(selectedValue) {
      this.selectedBank = selectedValue
      this.postForm.bank_account_id = selectedValue.id
    },
    handleKeyup(amount) {
      amount = parseFloat(amount)
      if (this.selectedPayment.price_list.indexOf(amount) !== -1) {
        this.checkedItem = 'amount_' + amount
      } else {
        this.checkedItem = 'amount_custom'
      }
      if (this.selectedPayment.usdt_rate !== undefined) {
        this.USDT = amount * this.selectedPayment.usdt_rate
        this.USDT = Math.floor(this.USDT * 100) / 100
      }
      this.calculateBonus(amount)
    },
    handleAmount(amount) {
      if (!this.firstLoad) {
        this.amountChange = true
      }
      this.postForm.amount = amount
      if (!amount) {
        this.checkedItem = 'amount_custom'
      } else {
        this.checkedItem = 'amount_' + amount
      }
      if (this.selectedPayment.usdt_rate !== undefined) {
        this.USDT = amount * this.selectedPayment.usdt_rate
        this.USDT = Math.floor(this.USDT * 100) / 100
      }
      this.calculateBonus(amount)
    },
    copyOfModal(text) {
      copyTextOfModal('modal_bank_info_body', text)
    },
    copy(text) {
      copyText(text)
    },
    handleSubmit() {
      const self = this

      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.$store.commit('SET_LOADING', true)
          this.actionLoading = true

          if (this.eventJoin) {
            this.postForm.other = true
            this.postForm.event_type = 'deposit_v2'
            this.postForm.event_join = true
          } else {
            this.postForm.other = false
            this.postForm.event_type = 'deposit_v2'
            this.postForm.event_join = false
          }

          if (this.selectedType.id === 'manual') {
            // 人工
            DepositManual(this.postForm)
              .then((response) => {
                // this.$router.push({ name: 'DepositRecord' }).catch(() => {
                // })

                this.$bvModal.show('modal_bank_info')
                // showNotice(response.data.msg)
              })
              .catch((error) => {
                setErrorMessage(error.response, this.errors)
              })
              .finally(() => {
                this.$store.commit('SET_LOADING', false)
                this.actionLoading = false
              })
          } else {
            if (!this.$store.getters.deviceInfo.is_webview) {
              var newWindow = window.open('/loading.html', '_blank')
            }

            // 第三方
            DepositPayment(this.postForm)
              .then((response) => {
                const result = response.data.data

                this.url = result.content
                if (newWindow !== undefined) {
                  newWindow.location = this.url

                  showNotice(
                    this.$t('Bao.deposit_processing_notice'),
                    function() {
                      self.$router
                        .push({ path: '/payment/deposit-record' })
                        .catch(() => {
                        })
                    }
                  )

                  // 偵測新視窗是否關閉
                  var startCheck = false
                  self.listenTimer = window.setInterval(function() {
                    try {
                      var newHost = newWindow.location.host
                    } catch (e) {
                      newHost = 'cross domain'
                    }

                    console.log('detect..', newHost, startCheck)
                    if (newHost !== window.location.host) {
                      startCheck = true
                    }

                    if (newHost === window.location.host && startCheck) {
                      // 新視窗回到包網
                      newWindow.close()
                      window.clearInterval(self.listenTimer)
                      showNotice('closeModal')
                      self.$router
                        .push({ path: '/payment/deposit-record' })
                        .catch(() => {
                        })
                    } else if (newWindow.closed) {
                      // 新視窗已經關閉
                      window.clearInterval(self.listenTimer)
                      showNotice('closeModal')
                      self.$router
                        .push({ path: '/payment/deposit-record' })
                        .catch(() => {
                        })
                    }
                  }, 1000)
                } else {
                  // app不另開視窗
                  window.location = this.url
                }
              })
              .catch((error) => {
                setErrorMessage(error.response, this.errors)

                if (newWindow !== undefined) {
                  newWindow.close()
                }
              })
              .finally(() => {
                this.$store.commit('SET_LOADING', false)
                this.actionLoading = false
              })
          }
        }
      })
    },
    showModal() {
      this.$bvModal.show('modal_set')
    },
    hideModal() {
      this.$bvModal.hide('modal_set')
    },
    goToCsPage() {
      window.open(this.depositBankcardInternal.cs_url)
    },
    getPrize(amount) {
      for (const i in this.eventDetail.setting) {
        const set = this.eventDetail.setting[i]
        if (amount >= set.min_deposit_amount && amount <= set.max_deposit_amount) {
          return this.$options.filters['numberFormat'](set.prize)
        }
      }
      return ''
    },
    getUpper(amount) {
      for (const i in this.eventDetail.setting) {
        const set = this.eventDetail.setting[i]
        if (amount >= set.min_deposit_amount && amount <= set.max_deposit_amount) {
          return set.upper_limit
        }
      }
      return 0
    },
    calculateBonus(amount) {
      if (isNaN(amount)) {
        this.eventBonus = 0
        return
      }
      this.eventBonus = (amount * this.getPrize(amount)) / 100
      const upper = this.getUpper(amount)
      if (this.eventBonus > upper) {
        this.eventBonus = upper
      }
    },
    calulateTotalBonus() {
      // console.log(this.postForm.amount)
      if (this.postForm.amount === '') {
        return this.eventBonus
      } else {
        return parseInt(this.postForm.amount) + this.eventBonus
      }
    }
  }
}
</script>

<style scoped>
</style>
